<template>
  <div class="dashboard-panels">
    <div class="config-panel-header">
      <h2 class="text-h5 font-weight-bold mb-4" :style="{ color: $getColor('vuetifyColor1') }">
        <v-icon :color="$getColor('vuetifyColor1')" large class="mr-2">euro</v-icon>
        N3 / Anticipos
      </h2>
      <p class="text-subtitle-1 text--secondary">
        Gestiona los anticipos N3 y visualiza sus estadísticas.
      </p>
    </div>
    <v-divider class="mb-6"></v-divider>
    <div class="dashboard-panels--tabs mdtec-card no-padding dashboard_box">
      <v-tabs centered grow background-color="transparent" :color="$getColor('vuetifyColor1')" persistent>
        <v-tabs-slider></v-tabs-slider>
        <v-tab href="#tab-3" @click="isView = 1" v-if="availableN3">
          <v-icon class="mr-3">mdi-file-document-outline</v-icon>
          <span>EXPORTAR N3</span>
        </v-tab>
        <v-tab href="#tab-n3-stats" @click="isView = 3" v-if="availableN3">
          <v-icon class="mr-3">mdi-chart-bar</v-icon>
          <span>ESTADÍSTICAS</span>
        </v-tab>
      </v-tabs>
    </div>
    <div class="dashboard-panels--tabs mdtec-card">

      <!-- TAB 2 - N3 ANTICIPOS -->
      <div v-show="isView === 1" class="p-3">
        <ExportN3></ExportN3>
      </div>

      <!-- TAB 4 - ESTADISTICAS N3 -->
      <div v-if="isView === 3" class="p-3">
        <N3AdvancedStats />
      </div>

    </div>
  </div>
</template>
<script>
import ExportN3 from '@/views/_FATDA/components/ExportN3.vue';
import N3AdvancedStats from '@/views/_FATDA/components/N3AdvancedStats.vue';

export default {
  name: 'generate-n3',
  data() {
    return {
      workcenterId: null,
      workcenterName: null,
      isView: 1,
      availableN3: true,
    };
  },
  mounted() {
    if (this.$store.state.projectId === null) {
      if (this.$route.name !== 'SelectWorkCenter') {
        this.$router.push({ name: 'SelectWorkCenter' }).catch(() => {});
      }
    } else {
      this.workcenterId = this.$store.state.projectId;
      this.workcenterName = this.$store.state.project;
      if (this.$store.state.availableN3 === false || this.$store.state.availableN3 === 'false' || this.$store.state.availableN3 === 'null') {
        this.availableN3 = false;
      }
    }
  },
  components: {
    ExportN3,
    N3AdvancedStats,
  },
};
</script>
<style scoped>
.container-max-width {
  max-width: 800px;
}
</style>
